import Header from './../Header';
import Footer from './../Footer';

const BlogLayout = ({ hideHeaderFooter, hideLanguageSwitcher, children }) => {
  return (
    <>
      {!hideHeaderFooter && <Header hideLanguageSwitcher={hideLanguageSwitcher} />}
      <main>
        {children}
      </main>
      {!hideHeaderFooter && <Footer />}
    </>
  );
};

export default BlogLayout;